/* eslint-disable */
export default {
  to: 'À :',
  transferTo: 'Transférer à',
  blindTransfer: 'Transférer',
  warmTransfer: 'Demander d’abord',
  enterNameOrNumber: 'Entrer le numéro',
  toVoicemail: 'À la messagerie vocale',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To voicemail"@#@
